const en = {
  nav: {
    home: 'Home',
    about: 'About us',
    disciplines: 'Disciplines',
    goals: 'Goals',
    events: 'Events',
    documents: 'Documentation',
    docs_patriot: '«Patriot» Documentation',
    contacts: 'Contacts',
    admin: 'Administration',
    title: 'National Federation',
    subtitle: 'of military applied sports',
  },
  hero: {
    label: 'National Federation',
    title: "Warrior's Way",
    subtitle: '"NATIONAL FEDERATION OF MILITARY-APPLIED SPORTS" Public Organization',
    btn_about: 'About Federation',
    btn_events: 'Events',
  },
  stats: {
    athletes: 'Awards won',
    regions: 'Active members',
    events: 'UAE SWAT Challenge 2026 Medals',
    ranks: 'Years serving sports',
  },
  about: {
    title: 'About Federation',
    subtitle: 'National Federation',
    desc: '"NATIONAL FEDERATION OF MILITARY-APPLIED SPORTS" Public Organization unites top national athletes, advancing physical culture and combat readiness.',
  },
  disciplines: {
    title: 'Sport Disciplines',
  },
  goals: {
    title: 'Our Goals',
  },
  quote: {
    title: 'Here strength, character, and honor are born.',
    text: 'Military-applied sports are the path to mastery, responsibility, and service to the Motherland.',
  },
  events: {
    title: 'Upcoming Events',
  },
  footer: {
    rights: 'All rights reserved.',
    contacts: 'Contact Information',
  },
  admin: {
    title: 'Website Texts',
    save: 'Save',
    saved: 'Saved',
    lang_kk: 'Қазақша',
    lang_ru: 'Русский',
    lang_en: 'English',
  },
};

export default en;
